export default class Slider {
  constructor(elem) {
    this.elem = elem
    this.init()
  }

  init() {
    this.slider = new Swiper(this.elem, {
      loop: true,
      speed: 800,
      autoplay: {
        delay: 5400,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: '4%', //15/375
      breakpoints: {
        // 1400px以上のとき
        1400: {
          spaceBetween: 28
        },
        // 900px以上のとき
        900: {
          spaceBetween: '2%', //28/1400
        }
      }
    })
  }
}